import { render, staticRenderFns } from "./CurePlanAdd.vue?vue&type=template&id=159dee10&scoped=true&"
import script from "./CurePlanAdd.vue?vue&type=script&lang=js&"
export * from "./CurePlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159dee10",
  null
  
)

export default component.exports